import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { addCourse } from "../../../../redux/educator/actions";
import { setInitialSteps } from "../../../../redux/shared/actions";
import { StateType } from "../../../../utils/types";
import { selectCourseSubmitLoading } from "../../../../redux/educator/selector";

const mapStateToProps = (state: StateType) => ({
  submitLoading: selectCourseSubmitLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      addCourse,
      setInitialSteps,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
